import { Box, Button, Stack, Typography, useTheme } from "@mui/material"
import Backdrop from "@mui/material/Backdrop"
import { Link, useNavigate } from "react-router-dom"
import { useCallback, useMemo } from "react"
import { getIcon } from "utils/icon"
import { TabIcon } from "components/icons"
import { useTranslation } from "providers/i18n"

export const StandardFullScreenStart = ({ icon = null, path = "/maps" }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FullScreenStart`]?.styleOverrides || {}
  const {
    root,
    actionButton,
    actionButtonWrapper,
    doubleLineContainer,
    labelPrimary,
    labelSecondary,
  } = styleOverrides
  const navigate = useNavigate()

  const handleClose = useCallback(() => {
    navigate(path)
  }, [navigate, path])

  const startButtonIcon = useMemo(
    () => getIcon(theme?.assets?.startIcon) || <TabIcon />,
    [theme]
  )

  return (
    <Backdrop sx={root} open={true} onClick={handleClose}>
      <Box sx={actionButtonWrapper}>
        <Button
          component={Link}
          to={path}
          variant="contained"
          sx={actionButton}
          startIcon={icon ?? startButtonIcon}
        >
          <Stack sx={doubleLineContainer}>
            <Typography sx={labelPrimary}>
              {t("Start Explore Primary Label")}
            </Typography>
            <Typography sx={labelSecondary}>
              {t("Start Explore Secondary Label")}
            </Typography>
          </Stack>
        </Button>
      </Box>
    </Backdrop>
  )
}
